<template>
  <!-- 政治环境 -->
  <div class="table_container">
    <table>
      <tbody align="left">
        <tr>
          <th><span style="color: #F56C6C">*</span>政局形式</th>
          <td @click="handleColumn('politicalForm')">
            <el-select
              v-if="editField === 'politicalForm'"
              ref="focusRef"
              v-model="form.politicalForm"
              placeholder="请选择"
              filterable
              clearable
              size="mini"
              automatic-dropdown
              @visible-change="visibleChange"
              @change="confirmEdit"
            >
              <el-option
                label="非常稳定（政治环境和谐）"
                value="非常稳定（政治环境和谐）"
              ></el-option>
              <el-option
                label="相对稳定（偶尔小波动但稳定）"
                value="相对稳定（偶尔小波动但稳定）"
              ></el-option>
              <el-option
                label="中度不稳定（矛盾突出有执政压力）"
                value="中度不稳定（矛盾突出有执政压力）"
              ></el-option>
              <el-option
                label="高度不稳定（政治混乱且更迭频繁）"
                value="高度不稳定（政治混乱且更迭频繁）"
              ></el-option>
              <el-option
                label="政治动荡（冲突不断有战争风险）"
                value="政治动荡（冲突不断有战争风险）"
              ></el-option>
            </el-select>
            <span v-else>
              {{ form.politicalForm }}
            </span>
          </td>
          <th><span style="color: #F56C6C">*</span>本届政府执政日期</th>
          <td @click="handleColumn('politicalYears')">
            <el-date-picker
              v-if="editField === 'politicalYears'"
              ref="focusRef"
              v-model="form.politicalYears"
              type="year"
              value-format="yyyy"
              placeholder="请选择"
              size="mini"
              style="width: 100%"
              align="right"
              @blur="confirmEdit"
              @change="confirmEdit"
            >
            </el-date-picker>
            <span v-else>
              {{ form.politicalYears }}
            </span>
          </td>
          <th><span style="color: #F56C6C">*</span>下届选举日期（预计）</th>
          <td @click="handleColumn('politicalNextYears')">
            <el-date-picker
              v-if="editField === 'politicalNextYears'"
              ref="focusRef"
              v-model="form.politicalNextYears"
              type="year"
              value-format="yyyy"
              placeholder="请选择"
              size="mini"
              style="width: 100%"
              align="right"
              @blur="confirmEdit"
              @change="confirmEdit"
            >
            </el-date-picker>
            <span v-else>
              {{ form.politicalNextYears }}
            </span>
          </td>
        </tr>
        <tr @click="handleColumn('politicalText')">
          <td colspan="6" style="height: 80px">
            <el-input
              v-if="editField === 'politicalText'"
              ref="focusRef"
              v-model="form.politicalText"
              placeholder="请输入政局文本说明"
              clearable
              size="mini"
              type="textarea"
              @blur="confirmEdit"
            ></el-input>
            <span v-else>
              {{ form.politicalText }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { addOrUpdateBaseInfoApi } from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      form: this.getForm(),
      rules: {
        politicalForm: [
          { required: true, message: "政局形式不能为空", trigger: "blur" }
        ],
        politicalYears: [
          {
            required: true,
            message: "本届政府执政日期不能为空",
            trigger: "change"
          }
        ],
        politicalNextYears: [
          {
            required: true,
            message: "下届选举日期（预计）不能为空",
            trigger: "change"
          }
        ]
      },
      editField: "" // 编辑单元格
    };
  },
  methods: {
    init(data) {
      this.form = this.getForm(data || {});
    },
    // 获取表单数据
    getForm(data = {}) {
      return {
        id: data.id || "",
        areaName: data.areaName || "",
        countryName: data.countryName || "",
        politicalForm: data.politicalForm || "",
        politicalYears: data.politicalYears || "",
        politicalNextYears: data.politicalNextYears || "",
        politicalText: data.politicalText || ""
      };
    },
    // 点击单元格编辑
    handleColumn(field) {
      this.editField = field;
      this.$nextTick(() => {
        if (Array.isArray(this.$refs.focusRef)) {
          this.$refs.focusRef[0].focus();
        } else {
          this.$refs.focusRef.focus();
        }
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
    },
    // el-select 显示隐藏选项框时触发
    visibleChange(visible) {
      if (!visible) {
        this.confirmEdit();
      }
    },
    // 保存
    async handleSave(params) {
      for (const key in this.rules) {
        if (!this.form[key]) {
          this.$DonMessage.error(this.rules[key][0].message);
          return;
        }
      }
      try {
        const submitData = JSON.parse(JSON.stringify(this.form));
        const res = await addOrUpdateBaseInfoApi(submitData);
        if (res.status == 0) {
          this.$DonMessage.success("操作成功！");
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table_container {
  padding: 15px 18px 0 50px;
  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
  }
  th,
  td {
    border: 1px solid #dcdfe6;
    padding: 4px 12px;
    height: 40px;
    font-size: 14px;
    word-break: break-all;
  }
  th {
    background-color: #f2f2f2;
  }
  .number_input {
    width: 100%;
    padding: 0;
    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }
}
</style>
